// 统一的存储 key
export const FEATURE_TOURS_STORAGE_KEY = 'VIDU_FEATURE_TOURS';
export const PROCESSING_TOURS_STORAGE_KEY = 'VIDU_PROCESSING_TOURS';
export const SESSION_TOUR_COUNT_KEY = 'VIDU_SESSION_TOUR_COUNT'; // 会话级别的计数器

/** Tour 唯一标识 */
export const TOUR_KEYS = {
  /** 扩展新功能气泡 */
  EXTEND_TOUR: 'EXTEND_TOUR',
  /** 侧边栏 Claw 入口引导 */
  CLAW_ENTRY_TOUR: 'CLAW_ENTRY_TOUR',
} as const;

export type TourKeyType = (typeof TOUR_KEYS)[keyof typeof TOUR_KEYS];

/** Tour 功能提示列表,不受时间有效性和用户注册时间和会话次数限制 */
export const TOUR_FUNCTION_TIPS_LIST: TourKeyType[] = [TOUR_KEYS.EXTEND_TOUR];

/** Tour 元数据接口 */
export interface TourMetadata {
  /** 优先级（数字越大越优先） */
  priority: number;
  /** 显示结束日期，格式：'YYYY-MM-DD' 或 ISO 8601 */
  showEndDate?: string;
  /** 是否在小屏幕上禁用，默认禁用 */
  disableOnSmallScreen?: boolean;
  /** 最大显示次数，默认一次 */
  maxCount?: number;
  /** 显示间隔天数，需和 maxCount 一起使用 */
  intervalDays?: number;
  /** 当 maxCount > 1 时，如果 disableAfterClose 为 true，则代表手动关闭后不再显示，默认 true */
  disableAfterClose?: boolean;
  /** 新手引导上线时间，格式：'YYYY-MM-DD' 或 ISO 8601。判断条件：上线时间 > 用户注册时间 + 7天 */
  tourOnlineTime?: string;
}

/**
 * Tour 元数据配置
 *
 * 注意：这里只包含元数据，不包含 tourConfig（UI 内容）
 * tourConfig 由各个组件在渲染时提供
 */
export const TOUR_METADATA_CONFIG: Record<TourKeyType, TourMetadata> = {
  [TOUR_KEYS.EXTEND_TOUR]: {
    priority: 90,
    disableOnSmallScreen: true,
    maxCount: 1,
    disableAfterClose: true,
  },
  [TOUR_KEYS.CLAW_ENTRY_TOUR]: {
    priority: 95,
    showEndDate: '2026-08-31',
    disableOnSmallScreen: true,
    maxCount: 1,
    disableAfterClose: true,
  },
};
